import { createAction } from '@reduxjs/toolkit';

export const galleryBreadCrumbsActions = {
  navigateTo: createAction<{ navigateTo: string }>('GalleryBreadCrumbs/NavigateTo'),
};
